import { render, staticRenderFns } from "./DeactivatePicklrPopup.vue?vue&type=template&id=37d15ad3&scoped=true&"
import script from "./DeactivatePicklrPopup.vue?vue&type=script&lang=ts&"
export * from "./DeactivatePicklrPopup.vue?vue&type=script&lang=ts&"
import style0 from "./DeactivatePicklrPopup.vue?vue&type=style&index=0&id=37d15ad3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d15ad3",
  null
  
)

export default component.exports